/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable import/prefer-default-export */
import React from "react";

// HELPERS
import moment from "moment";

import styles from "./Home.module.scss";

const shareIcon = require("./imgs/icons/share-icon.svg");
const shareButton = require("./imgs/icons/share-button.svg");

/**
 * Returns headline dates
 */
const returnHeadlinesDates = () => (
  <p className={styles.headlineDates}>
    <span>{`W${moment().format("W")}`}</span>
    &nbsp;|&nbsp;
    <span>{`${moment().startOf("week").format("D")} - ${moment()
      .endOf("week")
      .format("D MMM YYYY")}`}</span>
  </p>
);

const returnHeroHeader = (title) => (
  <div className={styles.heroHeader}>
    <div />
    <p>{title}</p>
  </div>
);

/**
 * Renders hero card UI
 * @param {String} cardTitle
 * @param {String} cardStatHeader
 * @param {Number} cardStatSubHeader
 * @param {React.Element} graph
 */
const renderHeroCard = (
  component,
  cardTitle,
  cardStatHeader,
  cardStatSubHeader,
  graph
) => (
  <div className={styles.cardContainer}>
    <div className={styles.cardHeader}>
      <p>{cardTitle}</p>
      <img
        onClick={() => component.handleOverlayAnimation("showShare")}
        alt='share'
        src={shareIcon}
      />
    </div>
    <div className={styles.statsContainer}>
      <h3>{cardStatHeader}</h3>
      <div>
        <p
          className={cardStatSubHeader > 0 ? styles.positive : styles.negative}
        >
          {`${cardStatSubHeader}${cardStatSubHeader ? "%" : ""}`}
        </p>
        <span>{cardStatSubHeader ? `YoY` : ""}</span>
      </div>
    </div>
    {/* TODO: THIS WILL EVENTUALLY NEED TO BE A DYNAMICALLY RENDERED GRAPH */}
    <div className={styles.graphContainer}>{graph}</div>
  </div>
);

/**
 * Renders placeholder graph
 * @param {String} title
 * @param {Image} graph
 */
const renderGraph = (component, title, subTitle, graph, state) => {
  const value = state !== null ? component.state[state] : null; // eslint-disable-line
  return (
    <div className={styles.placeHolderGraphContainer}>
      <div className={styles.placeHolderGraphHeader}>
        <p>
          {title}
          <br />
          <span
            style={
              subTitle === "Indexed trend view"
                ? { fontFamily: "Roboto Regular" }
                : null
            }
          >
            {subTitle}
          </span>
        </p>
        <div>
          <img
            onClick={() => component.handleOverlayAnimation("showShare")}
            alt='share-button'
            src={shareButton}
          />
        </div>
      </div>
      {value !== null ? (
        <div className={styles.graphFilterContainer}>
          <div
            onClick={() => component.setState({ [state]: true })}
            className={value ? styles.activeGraphFilter : null}
          >
            <p>Top 5</p>
          </div>
          <div
            onClick={() => component.setState({ [state]: false })}
            className={!value ? styles.activeGraphFilter : null}
          >
            <p>Closest</p>
          </div>
        </div>
      ) : null}
      {graph}
    </div>
  );
};

export { returnHeadlinesDates, returnHeroHeader, renderHeroCard, renderGraph };
